const MODULE_NAME = 'UsersModule';

export const SET_CURRENT_USER = `${MODULE_NAME}/SET_CURRENT_USER`;
export const LOCAL_SET_CURRENT_USER = 'SET_CURRENT_USER';
